import React, { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";

import { formatDate } from "../../helpers/order_format";
import { AppDispatch, RootState } from "../../store";
import { getTime } from "../../store/slices/timeSlice"

import {
  BackButton,
  ButtonContainer,
  CustomStepTitle,
  Description,
  NextButton,
  NoSlotsWarn,
  StepContainer,
  TimeSlot,
  TimeSlotWrapper,
} from "./styles";

export type TimeSlot = string;

type BookingStepTimeProps = {
  date: Date | null;
  selectedSlot: TimeSlot | null;
  onSelectSlot: (slot: TimeSlot) => void;
  onNext: () => void;
  onBack: () => void;
};

export const BookingStepTime: React.FC<BookingStepTimeProps> = ({
  date,
  selectedSlot,
  onSelectSlot,
  onNext,
  onBack,
}) => {
  const dispatch = useDispatch<AppDispatch>();

  const slots = useSelector((state: RootState) => state.time.time);
  const loading = useSelector((state: RootState) => state.time.loading);

  useEffect(() => {
    if (date) {
      dispatch(getTime(formatDate(date)));
    }
  }, [date, dispatch]);

  return (
    <StepContainer>
      <CustomStepTitle>Выберете свободное время</CustomStepTitle>
      <Description>*время московское</Description>

      {loading && <p style={{ textAlign: "center", height: "55px" }}>Загрузка...</p>}

      {!loading && slots.length === 0 && <NoSlotsWarn>Нет доступных слотов</NoSlotsWarn>}

      {!loading && slots.length > 0 && (
        <TimeSlotWrapper>
          {slots.map((slot) => (
            <TimeSlot
              key={slot}
              onClick={() => onSelectSlot(slot)}
              selected={slot === selectedSlot}
            >
              <span>{slot}</span>
            </TimeSlot>
          ))}
        </TimeSlotWrapper>
      )}

      <ButtonContainer>
        <BackButton onClick={onBack}>Назад</BackButton>
        <NextButton
          onClick={onNext}
          disabled={!selectedSlot || slots.length === 0}
        >Далее
        </NextButton>
      </ButtonContainer>
    </StepContainer>
  );
};
